import ReactDOM from 'react-dom';
import './style.css';
import WebContent from './app';

ReactDOM.render(<WebContent />, document.getElementById('root'));


